import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getOperationDetails } from '../../api/cafmApi'
import { setPayload } from './EditFieldMappinPayloadSlice'

// Async thunk to fetch operation details
export const fetchOpeationDeatils = createAsyncThunk<
  Record<string, string>,
  _OperationDetailsRequest,
  { rejectValue: string }
>('OpeationDetails/fetchOpeationDeatils', async (payload, { rejectWithValue, dispatch }) => {
  try {
    const response = await getOperationDetails(payload!)
    const details = response.data
    if (details.exist) {
      dispatch(
        setPayload({
          type: 'SET_ERROR',
          payload: { error: 'API URL and Method with Decider value and fields already exist' },
        }),
      )
    }
    return details
  } catch (error) {
    return rejectWithValue(error.message)
  }
})

export type _OperationDetailsRequest = {
  integation_id: string
  api_endpoint_url: string
  api_method: string
  object_type: string
  decider_fields_name: string
  decider_fields_value: string[]
}

type resultType = {
  exist: boolean
}
export type _OperationDetails = {
  previous_request: _OperationDetailsRequest | Record<string, never>
  initial_request: _OperationDetailsRequest | Record<string, never>
  result: resultType
}

const initialState: { OpeationDetails: _OperationDetails; loading: boolean; error: string | null } = {
  OpeationDetails: {
    previous_request: {},
    initial_request: {},
    result: { exist: false },
  },
  loading: false,
  error: null,
}

const OpeationDetailsSlice = createSlice({
  name: 'OpeationDetails',
  initialState,
  reducers: {
    setPrevRequest: (state, action) => {
      state.OpeationDetails.previous_request = action.payload
    },
    setInitialRequest: (state, action) => {
      state.OpeationDetails.initial_request = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOpeationDeatils.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchOpeationDeatils.fulfilled, (state, action) => {
        state.loading = false
        state.OpeationDetails.result = action.payload as unknown as resultType
      })
      .addCase(fetchOpeationDeatils.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  },
})
export const { setPrevRequest, setInitialRequest } = OpeationDetailsSlice.actions
export default OpeationDetailsSlice.reducer
